// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".separator_form[data-v-e30437b8]{margin:auto;margin-bottom:1.5rem;max-width:520px}.resumen_copy[data-v-e30437b8]{margin:auto;max-width:600px;line-height:27px}@media screen and (max-width:767px){.separator_form[data-v-e30437b8]{width:80%;margin:0 auto;margin-bottom:20px}.resumen_grid._2[data-v-e30437b8]{grid-template-rows:auto auto 1fr}}", ""]);
// Exports
module.exports = exports;
